import React, { Component } from 'react';
import { connect } from 'react-redux';

import InsuranceContractForm from '../../components/InsuranceContractForm';

import { findContract, updateContract } from 'actions/insuranceContracts';
import { getSubmitStatus, getContract } from 'reducers';

class UpdateContract extends Component {
  componentDidMount() {
    this.props.findContract(this.props.match.params.id);
  }

  transformValues = (values) => {
    let newValues = {};

    Object.keys(values).forEach((key) => {
      const fieldValue = values[key];
      if (fieldValue) {
        newValues[key] = fieldValue;
      }
    });

    return newValues;
  };

  render() {
    const { saveStatus, onSubmit, contract } = this.props;

    return (
      <React.Fragment>
        <h1>Update Device Protection Contract</h1>
        <br />
        <InsuranceContractForm
          saveStatus={saveStatus}
          initialValues={contract}
          onSubmit={(values) => onSubmit(this.transformValues(values))}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (
  state,
  {
    location,
    match: {
      params: { id },
    },
  },
) => ({
  saveStatus: getSubmitStatus(state, 'insuranceContract'),
  contract: getContract(state, id),
});

const mapDispatchToProps = {
  findContract,
  onSubmit: updateContract,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateContract);
